import './App.css';
import { useState } from 'react';
import { Form } from './components/Form';
import { TotalMoney } from './components/TotalMoney';
import { Header } from './components/Header';
import { List } from './components/List';
import { HomePage } from './components/HomePage';

function App() {

  //A lista original onde estão todos as transações
  const [listTransactions, setListTransactions] = useState([

      {description: 'Salário recebido', type: 'Entrada', value: 2500},
      {description: 'Conta', type: 'Saída', value: 150},

  ]);

  const [isHome, setIsHome] = useState(true);

  const [statusAllButton, setStatusAllButton] = useState(true);
  const [statusEntryButton, setStatusEntryButton] = useState(false);
  const [statusOutButton, setStatusOutButton] = useState(false);

  //list será usado para fazer os filtros.
  const [list, setList] = useState(listTransactions);
  const [isFiltered, setIsFiltered] = useState(false);

  function filtered (transactionType) {

      const listFiltered = listTransactions.filter((item) => item.type === transactionType);
      setList(listFiltered);

  }

  return (
    
    <div className="App">

      {
        isHome ? (

          <HomePage setIsHome={setIsHome}/>

        ) : (

          <>

            <Header setIsHome={setIsHome}/>

            <main>

              <div>
                <Form 
                  listTransactions={listTransactions} 
                  setListTransactions={setListTransactions} 
                  setIsFiltered={setIsFiltered}
                  setStatusAllButton={setStatusAllButton}
                  setStatusEntryButton={setStatusEntryButton}
                  setStatusOutButton={setStatusOutButton}
                />

                {
                  isFiltered ? (

                    <TotalMoney someValueTransactions={list}/>

                  ) : (

                    <TotalMoney someValueTransactions={listTransactions}/>

                  )
                }
                
              </div>

              <div>

                <div className="resumo">

                    <h2 className="title">Resumo Financeiro</h2>

                    <ul className="filter">

                        <li>
                            <button 

                                onClick={() => {

                                  setStatusAllButton(true);
                                  setStatusEntryButton(false);
                                  setStatusOutButton(false);
                                  setIsFiltered(false);

                                }}
                                className={statusAllButton ? 'ativo' : 'desativo'}>Todos

                            </button>
                        </li>

                        <li>
                          <button 
                            onClick={() => {
                            
                              setStatusAllButton(false);
                              setStatusEntryButton(true);
                              setStatusOutButton(false);
                              filtered('Entrada');
                              setIsFiltered(true);
                        
                            }}
                        
                            className={statusEntryButton ? 'ativo' : 'desativo'}>Entradas
                          </button>
                        </li>

                        <li>
                          <button 
                            onClick={() => {
                                  
                              setStatusAllButton(false);
                              setStatusEntryButton(false);
                              setStatusOutButton(true);
                              filtered('Saída');
                              setIsFiltered(true);

                            }} 

                            className={statusOutButton ? 'ativo' : 'desativo'}>Saída
                          </button>
                        </li>

                    </ul>
                </div>

                <List listTransactions={listTransactions} setListTransactions={setListTransactions} list={list} setList={setList} isFiltered={isFiltered}/>
                
              </div>
            </main>

          </>
        )  
      }  

      

    </div>
  );
}

export default App;
